import {createContext, useContext} from 'react';

/**
 * La manija para abrir el panel «Documentos y notas» desde cualquier objeto de la página: la
 * línea de fuentes, el botón de Drive de la Barra Total, el archivo de Memoria, el modal de la
 * cuenta.
 *
 * Vive en su propio módulo, separado del panel, a propósito: el panel importa la vista de Fuentes
 * entera (conexiones de Drive, tabla de documentos, Paquete de Contexto), y los consumidores de la
 * manija son objetos livianos que no tienen por qué arrastrar todo eso — ni en el bundle de una
 * pantalla que no abre el panel, ni en sus tests.
 *
 * Fuera del Recorrido —donde no hay provider— devuelve un no-op con `available: false`, y cada
 * consumidor cae a su comportamiento de siempre (un link).
 */

const NOOP_DRAWER = {available: false, openSources: () => {}};

export const SourcesDrawerContext = createContext(null);

export function useSourcesDrawer() {
    return useContext(SourcesDrawerContext) || NOOP_DRAWER;
}
